export default `blog-toc-title = Dans cet article
`;